import { useCurrentUser } from '@/contexts';
import { useNotes } from '@/hooks';
import { NotesCircles } from './NotesCircles';

export function NotesRow() {
  const { user } = useCurrentUser();
  const { myNote, entries } = useNotes(user);
  return <NotesCircles layout="row" myNote={myNote} entries={entries} />;
}
